module.exports = "small {\n  color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/errors/errors.component.css
// module id = ./src/app/core/components/errors/errors.component.css
// module chunks = main